import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Navbar from '../components/Header/Navbar';
import Footer from '../components/Footer';
import AdListGridItem from '../components/AdList/AdListGridItem';
import { favoriteListingService } from 'api/services/FavoriteListingService';
import { listingViewModelToAdListing } from 'api/utils/listingMapper';
import type { AdListing } from 'types/adListing';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Favoriler: React.FC = () => {
  const { user } = useAuth();
  const [favorites, setFavorites] = useState<AdListing[]>([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState<string | null>(null);

  const fetchFavorites = useCallback(async () => {
    if (!user?.id) {
      setFavorites([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setFetchError(null);
    try {
      const result = await favoriteListingService.getByUserId(user.id);
      if (result.isSuccess && result.data) {
        const list = result.data
          .filter((f) => f.listing != null)
          .map((f) =>
            listingViewModelToAdListing({ ...f.listing!, isUserFavorite: true })
          );
        setFavorites(list);
      } else {
        setFavorites([]);
        setFetchError(result.message ?? 'Favoriler yüklenemedi.');
      }
    } catch (err) {
      setFavorites([]);
      setFetchError(err instanceof Error ? err.message : 'Bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  useEffect(() => {
    fetchFavorites();
  }, [fetchFavorites]);

  const toggleFavorite = async (listingId: string | number, e: React.MouseEvent) => {
    e.preventDefault();
    if (!user?.id) return;
    const result = await favoriteListingService.toggle({
      userId: user.id,
      listingId: String(listingId),
    });
    if (result.isSuccess) {
      setFavorites((prev) => prev.filter((item) => item.id !== listingId));
    }
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: 'var(--sb-bg-muted)' }}>
      <Navbar />

      <main className="container py-4">
        <h1 className="mb-4">Favori İlanlarım</h1>

        {fetchError && (
          <div className="alert alert-warning mb-3" role="alert">
            {fetchError}
          </div>
        )}

        {loading ? (
          <div className="text-center py-5 text-muted">
            <div className="spinner-border text-primary mb-2" role="status" />
            <p>Favoriler yükleniyor...</p>
          </div>
        ) : favorites.length > 0 ? (
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            {favorites.map((item) => (
              <AdListGridItem
                key={item.id}
                ilan={item}
                detailLinkBase="/ilan-detay-login"
                onToggleFavorite={toggleFavorite}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-5 w-100">
            <i className="fas fa-heart fa-3x text-muted mb-3" />
            <h3>Henüz favori ilanınız yok</h3>
            <p className="text-muted">
              Beğendiğiniz ilanları favorilere ekleyerek daha sonra kolayca ulaşabilirsiniz.
            </p>
            <Link className="btn btn-primary" to="/">
              İlanlara Göz At
            </Link>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default Favoriler;
